(function () {
  class GoldenClawModifier extends PIXI.Container {
    constructor() {
      super();

      this.visible = false;
      gameData.goldenClawModifier = this;
      this.reelsMovedToLeft = false;

      this.currentLayoutIndex = 0;
      this.currentLayoutIndexLimit = 0;
      this.currentLayoutSize = 0;
      this.layoutIndexLimits = {
        2: 4,
        3: 3,
      };
      this.layoutsRequired = [
        {
          2: [[0], [1], [2], [3, 4]],
          3: [[0], [1], [2, 3, 4]],
        },
        {
          2: [[0, 1], [2], [3], [4]],
          3: [[0, 1, 2], [3], [4]],
        },
        {
          2: [[0], [1, 2], [3], [4]],
          3: [[0], [1, 2, 3], [4]],
        },
        {
          2: [[0], [1], [2, 3], [4]],
          3: [[0], [1], [2, 3, 4]],
        },
        {
          2: [[0], [1], [2], [3, 4]],
          3: [[0], [1], [2, 3, 4]],
        },
      ];
      this.blockDistributions = [
        {
          2: '1-1-1-2',
          3: '1-1-3',
        },
        {
          2: '2-1-1-1',
          3: '3-1-1',
        },
        {
          2: '1-2-1-1',
          3: '1-3-1',
        },
        {
          2: '1-1-2-1',
          3: '1-1-3',
        },
        {
          2: '1-1-1-2',
          3: '1-1-3',
        },
      ];
      this.symbolsToRemove = {
        2: [
          [false, false, false, false, false],
          [false, false, false, false, false],
          [false, false, false, false, false],
          [true, true, true, true, true],
        ],
        3: [
          [false, false, false, false, false],
          [false, false, false, false, false],
          [true, true, true, true, true],
        ],
      };

      this.cascadeSounds = ['cascade1', 'cascade2', 'cascade3'];
      this.explodeSounds = ['explode1', 'explode2', 'explode3'];
    }

    initialise() {
      messageBus.subscribe('spinner:GameConfigEvent', () => {
        this.onLayoutComplete();
      });
      messageBus.subscribe('game:goldenClawModifier', (event) => {
        this.onGoldenClawModifier(event);
      });
    }

    onLayoutComplete() {
      this.baseName = this.name + ':';
      this.grabReferences();
      this.setupSpineAnims();
      this.setupMasks();
    }

    grabReferences() {
      this.gigabloxFactory = resourceManager.get('slotContainer:GigabloxFactory');
      this.screenShaker = resourceManager.get('screenShaker');
      this.moveContainer0 = resourceManager.get('slotContainer:moveReelsContainer:moveReelsContainer0');
      this.moveContainer1 = resourceManager.get('slotContainer:moveReelsContainer:moveReelsContainer1');
      this.reelContainer = resourceManager.get('slotContainer:reelContainer');
      // this.reels = [];
      // for (let i = 0; i < reelManager.reels.length; i++) {
      //   const reel = resourceManager.get(`slotContainer:reelContainer:reel${i}`);
      //   this[`reel${i}`] = reel;
      //   this.reels[i] = reel;
      // }
    }

    setupSpineAnims() {
      // 2 anims to create
      // scratch and claw
      this.scratchAnim = resourceManager.createObject('spine', 'claw_marks', this.baseName + 'scratchAnimContainer', {
        name: 'claw_marks',
        scaleX: 1,
        scaleY: 1,
        x: 0,
        y: 0,
      });
      this.scratchAnim.visible = false;

      this.clawAnim = resourceManager.createObject('spine', 'claw', this.baseName + 'clawAnimContainer', {
        name: 'claw',
        scaleX: 1,
        scaleY: 1,
        x: 0,
        y: 0,
      });
      this.clawAnim.visible = false;
    }

    setupMasks() {
      this.animMask = new PIXI.Graphics();
      this.animMask.beginFill(0xff0000, 1);
      this.animMask.drawRect(-388, 17, 630, 630);
      this.animMask.endFill();
      this.mask = this.animMask;
      this.addChild(this.animMask);
    }

    async onGoldenClawModifier(event) {
      event.join();

      await this.doModifier(event.data);

      event.leave();
    }

    scaleAnimsForWidth(width) {
      // width will be 2 or 3
      if (width === 2) {
        this.clawAnim.scale.set(0.8, 1);
        this.clawAnim.position.set(0, 0);
        this.scratchAnim.scale.set(0.8, 1);
        this.scratchAnim.position.set(0, 0);
      } else {
        this.clawAnim.scale.set(1, 1);
        this.clawAnim.position.set(-96, 0);
        this.scratchAnim.scale.set(1, 1);
        this.scratchAnim.position.set(-96, 0);
      }
    }

    async playIntroAnim() {
      this.playClawAnim();
      await this.playScratchAnim();
    }

    async doModifier(data) {
      this.visible = true;

      this.currentLayoutIndex = 0;
      this.currentLayoutIndexLimit = this.layoutIndexLimits[data.modifierData.slashWidth];
      this.currentLayoutSize = data.modifierData.slashWidth;

      this.scaleAnimsForWidth(data.modifierData.slashWidth);

      await this.playIntroAnim();

      const reels = await this.hideSymbols(data.modifierData);
      const initialSymbols = Utils.shrinkArrayBasedOnBlockDistribution(
        this.buildSymbolsForInitialSwitch(data.modifierData),
        this.blockDistributions[this.currentLayoutIndex][data.modifierData.slashWidth]
      );
      await this.switchToNewLayout(data.modifierData, initialSymbols);
      await this.showHiddenSymbols(data.modifierData, reels);
      await this.dropNewSymbols(data.modifierData);

      await timerManager.delayAsync(500);

      await this.moveReelsToTheRight(data.modifierData);

      await timerManager.delayAsync(500);

      this.visible = false;
    }

    async playClawAnim() {
      await Utils.playSpineAsync('animation', this.clawAnim, false);
    }

    async playScratchAnim() {
      soundManager.play('scratch');
      await Utils.playSpineAsync('Claw', this.scratchAnim, false);
    }

    async hideSymbols(modifierData) {
      const reels = this.gigabloxFactory.getReelVisuals();
      const startingReelIndex = modifierData.slashWidth === 3 ? 2 : 3;
      const numOfReelsToClear = modifierData.slashWidth;

      const soundIndex = Math.floor(Math.random() * this.explodeSounds.length);
      soundManager.play(this.explodeSounds[soundIndex]);

      const disappearAnimPromises = [];
      for (let reel = 0; reel < numOfReelsToClear; reel++) {
        const reelIndex = reel + startingReelIndex;
        for (let row = 0; row < gameController.symbolDisappearAnims[reelIndex].length; row++) {
          const anim = gameController.symbolDisappearAnims[reelIndex][row];
          anim.x = anim.origX;
          anim.y = anim.origY;
          anim.scale.set(0.485);
          disappearAnimPromises.push(Utils.playMovieAsync(anim));
        }
      }

      await timerManager.delayAsync(250);

      for (let reel = 0; reel < numOfReelsToClear; reel++) {
        const reelIndex = reel + startingReelIndex;
        const reelObject = reels[reelIndex];
        for (let row = 0; row < reelObject._symbolGfxObjects.length; row++) {
          reelObject._symbolGfxObjects[row].renderable = false;
        }
      }

      await Promise.all(disappearAnimPromises);

      return reels;
      // now we should be left with a nice blank reel
    }

    // this reverts the previous hiding of symbols
    async showHiddenSymbols(modifierData, reels) {
      const startingReelIndex = modifierData.slashWidth === 3 ? 2 : 3;
      const numOfReelsToClear = modifierData.slashWidth;

      for (let reel = 0; reel < numOfReelsToClear; reel++) {
        const reelIndex = reel + startingReelIndex;
        const reelObject = reels[reelIndex];
        for (let row = 0; row < reelObject._symbolGfxObjects.length; row++) {
          reelObject._symbolGfxObjects[row].renderable = true;
        }
      }
    }

    buildSymbolsForInitialSwitch(modifierData) {
      const symbols = [];

      // // grab symbols from comms
      for (let reelIndex = 0; reelIndex < modifierData.slashBoard.stopWindow.reelList.length; reelIndex++) {
        const reelList = modifierData.slashBoard.stopWindow.reelList[reelIndex].symbols;
        symbols[reelIndex] = reelList.map(function (reel, index) {
          return reel.value;
        });
      }

      const reels = this.gigabloxFactory.getReelVisuals();
      for (let reelIndex = 0; reelIndex < reels.length; reelIndex++) {
        const reel = reels[reelIndex];
        const reelData = reel._reelSpinnerData;
        const symbolData = reelData._symbolData;

        // grab all the pre
        for (let i = 0; i < reelData._preAppertureSymbols; i++) {
          const offset = reelData._maxAppertureHeight;
          symbols[reelIndex][i + offset] = symbolData[i + offset].symId;
        }

        // grab all the post
        for (let i = 0; i < reelData._postAppertureSymbols; i++) {
          const offset = reelData._preAppertureSymbols + reelData._maxAppertureHeight;
          symbols[reelIndex][i + offset] = symbolData[i + offset].symId;
        }
      }

      // now we need to validate the post of the reels which are being updated
      const below = Utils.calcSymbolsBelow({
        symbolsAbove: [],
        blockDistribution: this.blockDistributions[this.currentLayoutIndex][modifierData.slashWidth],
        board: modifierData.slashBoard,
        fillEmptyGaps: false,
        disableBonusTease: true,
      });
      // below will only contain entries for the giga reels if there is overlap

      let belowSymbolsToAdd = 0;
      for (let reelIndex = 0; reelIndex < below.length; reelIndex++) {
        const reel = reels[reelIndex];
        const reelData = reel._reelSpinnerData;

        if (Utils.isArray(below[reelIndex])) {
          if (!belowSymbolsToAdd) {
            belowSymbolsToAdd = below[reelIndex].length;
          }

          for (let i = 0; i < belowSymbolsToAdd; i++) {
            const offset = reelData._preAppertureSymbols + reelData._maxAppertureHeight;
            symbols[reelIndex][i + offset] = below[reelIndex][i];
          }
        }
      }

      modifierData.extraToMoveUp = belowSymbolsToAdd;

      return symbols;
    }

    async switchToNewLayout(modifierData, symbols) {
      let resolver = null;
      const promise = new Promise((resolve) => {
        resolver = resolve;
      });

      this.gigabloxFactory.transitionWhenStopped(
        this.layoutsRequired[this.currentLayoutIndex][modifierData.slashWidth], //
        symbols,
        modifierData.extraToMoveUp,
        () => {
          resolver();
        }
      );

      await promise;
    }

    async dropNewSymbols(modifierData) {
      let resolver = null;
      const promise = new Promise((resolve) => {
        resolver = resolve;
      });

      const reels = this.gigabloxFactory.getReelVisuals();
      for (let reelIndex = 0; reelIndex < reels.length; reelIndex++) {
        const reel = reels[reelIndex];
        const reelData = reel._reelSpinnerData;
        const dropData = reelData.initialiseSymbolDropData(true);
        if (reelIndex === reels.length - 1) {
          // last reel
          // this the one were we need to update the timedeltas
          // manually
          for (let k = 0; k < dropData.length; k++) {
            dropData[k].delta = 5 + modifierData.extraToMoveUp;
          }
        }
      }

      const soundIndex = Math.floor(Math.random() * this.cascadeSounds.length);
      soundManager.play(this.cascadeSounds[soundIndex]);

      this.gigabloxFactory.dropSymbols(this.symbolsToRemove[modifierData.slashWidth], () => {
        this.shakeScreen(modifierData.slashWidth);
        resolver();
      });

      await promise;
    }

    shakeScreen(reelWidth) {
      if (this.screenShaker.isShaking()) {
        this.screenShaker.stop();
      }
      if (soundManager.isSoundPlaying('Rumble_Loop')) {
        soundManager.stop('Rumble_Loop');
        //let sfxId = soundManager.play("Hard_Hit");
        //gameController.setRumbleVolume(reelWidth, sfxId)
        gameController.sfxRumbleId = -1;
      }
      this.screenShaker.blockLanded(reelWidth);
    }

    async moveReelsToTheRight(modifierData) {
      const reels = this.gigabloxFactory.getReelVisuals();
      const startingReelIndex = modifierData.slashWidth === 3 ? 2 : 3;
      const numOfReelsToClear = 1; // giga reels are only 1 size - data.slashWidth;

      // adjusted reels is the new gigareel
      // we need to put the new gigareel into a new container (moveReelsContainer0)
      for (let i = 0; i < 1; i++) {
        const reelIndex = i + startingReelIndex;
        reels[reelIndex].origParent = reels[reelIndex].parent;
        this.moveContainer0.addChild(reels[reelIndex]);
        reels[reelIndex].origX = reels[reelIndex].x;
        reels[reelIndex].origY = reels[reelIndex].y;
        reels[reelIndex].x = 126 * i;
        reels[reelIndex].y = 0;
        reels[reelIndex].redraw();
      }

      // remaining reels into the other container
      for (let i = 0; i < startingReelIndex; i++) {
        const reelIndex = i;
        reels[reelIndex].origParent = reels[reelIndex].parent;
        this.moveContainer1.addChild(reels[reelIndex]);
        reels[reelIndex].origX = reels[reelIndex].x;
        reels[reelIndex].origY = reels[reelIndex].y;
        reels[reelIndex].x = 126 * i;
        reels[reelIndex].y = 0;
        reels[reelIndex].redraw();
      }

      const pivotXOffset = 126 / 2;

      this.moveContainer0.pivot.set((126 * 1) / 2, 630 / 2);
      this.moveContainer1.pivot.set((126 * startingReelIndex) / 2, 630 / 2);

      // positioning of container?
      this.moveContainer0.x = 126 * startingReelIndex + (126 / 2) * 1;
      this.moveContainer0.y = 630 / 2;

      this.moveContainer1.x = (126 * startingReelIndex) / 2;
      this.moveContainer1.y = 630 / 2;

      // everything positioned correctly now
      // we should be able to do our move and scale tweens on the 2 containers

      soundManager.play('columnSwapStart');

      const move0Tween = Utils.tweenFromToAsync(
        this.moveContainer0,
        {
          x: this.moveContainer0.x,
        },
        {
          x: (126 * 1) / 2,
          duration: 2,
          ease: 'power1.out',
        }
      );

      const move1Tween = Utils.tweenFromToAsync(
        this.moveContainer1,
        {
          x: this.moveContainer1.x,
        },
        {
          x: (126 * startingReelIndex) / 2 + 126 * modifierData.slashWidth,
          duration: 2,
          ease: 'power1.out',
        }
      );

      const scaleUp0Tween = Utils.tweenFromToAsync(
        this.moveContainer0.scale,
        {
          x: 1,
          y: 1,
        },
        {
          x: 1.1,
          y: 1.1,
          duration: 1,
          ease: 'power1.out',
        }
      );

      const scaleDown1Tween = Utils.tweenFromToAsync(
        this.moveContainer1.scale,
        {
          x: 1,
          y: 1,
        },
        {
          x: 0.9,
          y: 0.9,
          duration: 1,
          ease: 'power1.out',
        }
      );

      await timerManager.delayAsync(1900);

      // soundManager.stop('columnSwapStart');
      soundManager.play('columnSwapEnd');

      // start scale down occur 100ms before the move tween finishes

      const scaleDown0Tween = Utils.tweenFromToAsync(
        this.moveContainer0.scale,
        {
          x: 1.1,
          y: 1.1,
        },
        {
          x: 1,
          y: 1,
          duration: 0.15,
          ease: 'none',
        }
      );

      const scaleUp1Tween = Utils.tweenFromToAsync(
        this.moveContainer1.scale,
        {
          x: 0.9,
          y: 0.9,
        },
        {
          x: 1,
          y: 1,
          duration: 0.15,
          ease: 'none',
        }
      );

      await move1Tween;
      await scaleUp1Tween;

      this.shakeScreen(1);

      // tweens appear to work

      this.reparentReels();

      // reels are all back in the original place
      // we need to switch layout again
      const symbols = this.gigabloxFactory.getSymbolsInWindow();
      // we need to move the array around
      symbols.unshift(symbols.pop());
      modifierData.extraToMoveUp = 0;
      this.currentLayoutIndex++;
      await this.switchToNewLayout(modifierData, symbols);

      const blockDistributionData = gameController.blockDistributionData;
      blockDistributionData.blockDistribution =
        this.blockDistributions[this.currentLayoutIndex][modifierData.slashWidth];
      blockDistributionData.board = modifierData.slashBoard;
    }

    reparentReels() {
      // let reparent all the reels
      const reels = this.gigabloxFactory.getReelVisuals();
      for (let i = 0; i < reels.length; i++) {
        const reel = reels[i];
        reel.origParent.addChildAt(reel, i);
        reel.x = reel.origX;
        reel.y = reel.origY;
        reel.redraw();
      }
    }

    getOrigSymbolIds() {
      const origReelSymbolIds = [];
      for (let i = 0; i < reelManager.reels.length; i++) {
        origReelSymbolIds[i] = [];
        for (let s = 0; s < reelManager.reels[i].symbolData.length; s++) {
          origReelSymbolIds[i][s] = reelManager.reels[i].symbolData[s].symbolId;
        }
      }

      return origReelSymbolIds;
    }

    getReelIndexMapping(size, position) {
      return this.reelIndexMapping[size][position];
    }

    // called by game controller before any wins are processed
    async moveReelsToTheLeft(event) {
      this.reelsMovedToLeft = false;
      this.gigabloxFactory.clearSplitBlocks();

      // now we move over

      // need to work out where the gigablox reels are,
      // and work out the next reel which needs moving
      // should only move 1 reel at a time

      // based on the current layout index and the size, we should know where the gigabloc reel is
      // we should also know if we ask the visual reel
      const reels = this.gigabloxFactory.getReelVisuals();

      let goldenClawSize = -1;
      let gigaAdded = false;
      let startingClawReelIndex = -1;
      let startingNormalReelIndex = -1;
      let singleAdded = false;
      for (let i = 0; i < reels.length; i++) {
        const reel = reels[i];
        if (reel._blockSize > 1) {
          // we have found the gigareel - there will be only one of these now
          startingClawReelIndex = i;
          goldenClawSize = reel._blockSize;
          // this is a golden claw reel
          // this reel needs to be put into a different container for moving
          reel.origParent = reel.parent;
          this.moveContainer0.addChild(reel);
          reel.origX = reel.x;
          reel.origY = reel.y;
          reel.x = 126 * 1;
          reel.y = 0;
          gigaAdded = true;
        } else {
          if (gigaAdded === true && !singleAdded) {
            singleAdded = true;
            if (startingNormalReelIndex === -1) {
              startingNormalReelIndex = i;
            }
            // have we added the golden claw reels already
            // we just need to add this next reel, the others can stay
            reel.origParent = reel.parent;
            this.moveContainer1.addChild(reel);
            reel.origX = reel.x;
            reel.origY = reel.y;
            reel.x = 0;
            reel.y = 0;
          } else {
            // ignore - but store data for the reparentReels function
            reel.origParent = reel.parent;
            reel.origX = reel.x;
            reel.origY = reel.y;
          }
        }
      }

      if (goldenClawSize === 2) {
        this.moveContainer0.pivot.set(126 * goldenClawSize, 630 / 2);
      } else {
        this.moveContainer0.pivot.set(126 * goldenClawSize - 126 / 2, 630 / 2);
      }

      this.moveContainer1.pivot.set((126 * 1) / 2, 630 / 2);

      this.moveContainer0.x = 126 * startingClawReelIndex + (126 / 2) * goldenClawSize;
      this.moveContainer0.y = 630 / 2;

      this.moveContainer1.x = 126 * (startingClawReelIndex + goldenClawSize) + 126 / 2;
      this.moveContainer1.y = 630 / 2;

      // await Utils.waitForever();

      // we are all now in the correct place and ready to move
      const durationScaleFactor = 0.5;

      soundManager.play('columnSwapStart');

      const move0Tween = Utils.tweenFromToAsync(
        this.moveContainer0,
        {
          x: this.moveContainer0.x,
        },
        {
          x: this.moveContainer0.x + 126,
          duration: 2 * durationScaleFactor,
          ease: 'power1.out',
        }
      );

      const move1Tween = Utils.tweenFromToAsync(
        this.moveContainer1,
        {
          x: this.moveContainer1.x,
        },
        {
          x: this.moveContainer1.x - 126 * goldenClawSize,
          duration: 2 * durationScaleFactor,
          ease: 'power1.out',
        }
      );

      const scaleUp0Tween = Utils.tweenFromToAsync(
        this.moveContainer0.scale,
        {
          x: 1,
          y: 1,
        },
        {
          x: 1.1,
          y: 1.1,
          duration: 1 * durationScaleFactor,
          ease: 'power1.out',
        }
      );

      const scaleDown1Tween = Utils.tweenFromToAsync(
        this.moveContainer1.scale,
        {
          x: 1,
          y: 1,
        },
        {
          x: 0.9,
          y: 0.9,
          duration: 1 * durationScaleFactor,
          ease: 'power1.out',
        }
      );

      await timerManager.delayAsync(1900 * durationScaleFactor);

      // soundManager.stop('columnSwapStart');
      soundManager.play('columnSwapEnd');

      // start scale down occur 100ms before the move tween finishes

      const scaleDown0Tween = Utils.tweenFromToAsync(
        this.moveContainer0.scale,
        {
          x: 1.1,
          y: 1.1,
        },
        {
          x: 1,
          y: 1,
          duration: 0.15,
          ease: 'none',
        }
      );

      const scaleUp1Tween = Utils.tweenFromToAsync(
        this.moveContainer1.scale,
        {
          x: 0.9,
          y: 0.9,
        },
        {
          x: 1,
          y: 1,
          duration: 0.15,
          ease: 'none',
        }
      );

      await move1Tween;
      await scaleUp1Tween;

      this.shakeScreen(1);

      // everything has now all been moved
      // we now need to put everything back to where its supposed to be
      this.reparentReels();

      const symbols = this.gigabloxFactory.getSymbolsInWindow();
      Utils.swapArrayElements(symbols, startingClawReelIndex, startingNormalReelIndex);
      this.currentLayoutIndex++;
      await this.switchToNewLayout(
        {
          slashWidth: goldenClawSize,
          extraToMoveUp: 0,
        },
        symbols
      );

      const blockDistributionData = gameController.blockDistributionData;
      blockDistributionData.blockDistribution = this.blockDistributions[this.currentLayoutIndex][goldenClawSize];
      // blockDistributionData.board =
      // dont think we need to worry about board - this will have to be updated somewhere else, we dont have that info

      this.reelsMovedToLeft = true;
    }

    haveReelsMovedToTheLeft() {
      return this.reelsMovedToLeft;
    }

    goldenClawReelAtEnd() {
      let atEnd = true;
      if (this.currentLayoutIndex < this.currentLayoutIndexLimit) {
        atEnd = false;
      }
      return atEnd;
    }
  }

  //////////////////////////////////////////////////
  create = function (json) {
    return new GoldenClawModifier();
  };

  //////////////////////////////////////////////////
  initialise = function (json, container, resources) {
    container.initialise();
  };

  //////////////////////////////////////////////////
  getFilesRequired = function (json) {
    return ['', ''];
  };

  resourceManager.registerObjectType('GoldenClawModifier', create, initialise, getFilesRequired);
})();
